import axios from 'axios'

// The privileged equivalent of the admin onboarding guard: the token in
// the URL is only usable while it resolves to an unconfirmed user that
// belongs to no organization, which the verify endpoint decides.
async function beforeEnter(to, from, next) {
    try {
        const { token } = to.params
        const response = await axios.get(`onboarding/privileged/${token}`)
        const privilegedUser = response.data

        if (Object.keys(privilegedUser).length === 0) {
            next('login')
        } else {
            next()
        }
    } catch (e) {
        next('login')
    }
}

export default beforeEnter
